import {
    DEFAULT_COLUMN_WIDTHS,
    DEFAULT_HEADER_VALUES,
} from '@/components/preview/test-table-editor/constants';
import { createTableRow } from '@/lib/table-utils';
import {
    ChartBlock,
    DividerBlock,
    ImageBlock,
    TableBlock,
    TestBlock,
    TextBlock,
} from '@/types/report-payload';

export const generateNewBlock = (type: string, order: number): TestBlock => {
    const timestamp = Date.now();
    // Generate a simple unique ID that works in all environments
    const id = `${timestamp}-${Math.random().toString(36).substr(2, 9)}`;

    if (type === 'tool_table') {
        const columnCount = DEFAULT_HEADER_VALUES.length;
        return {
            id,
            block_type: 'table',
            order: order,
            has_content: true,
            description: '',
            automatic: false,
            header: createTableRow(columnCount, DEFAULT_HEADER_VALUES),
            rows: [],
            columnWidths: DEFAULT_COLUMN_WIDTHS,
        } as TableBlock;
    } else if (type === 'tool_chart') {
        return {
            id,
            block_type: 'chart',
            order: order,
            has_content: true,
            automatic: false,
            chart_type: 'bar',
            source_mode: 'manual',
            datapoints: { x_axis: [], y_axis: [] },
            measurement_type: 'Valor',
        } as ChartBlock;
    } else if (type === 'tool_image') {
        // Deliberately empty: the block is added first and renders a
        // placeholder, which is what gives the file picker's progress and any
        // upload error somewhere to appear.
        return {
            id,
            block_type: 'image',
            order: order,
            has_content: false,
        } as ImageBlock;
    } else if (type === 'tool_divider') {
        // Empty on purpose, like the image block above: the category is picked
        // from the placeholder this renders as, once the divider is sitting at
        // the point in the laudo where the new section actually starts.
        return {
            id,
            block_type: 'divider',
            order: order,
            has_content: true,
            title: '',
            description: '',
            awaiting_category: true,
        } as DividerBlock;
    } else {
        return {
            id,
            block_type: 'text',
            order: order,
            has_content: true,
            automatic: false,
            content: '',
        } as TextBlock;
    }
};
